import React, { lazy } from 'react';
const NIVEL_1_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779242782/hf_20260520_020049_0eeba2a6-8acc-4874-ab6c-5938c9f662ef_jqjjpz.webp';
const NIVEL_2_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779243001/hf_20260520_020348_61b99a6c-8dd9-42a0-9344-cb040b050e9d_vor2uz.webp';
const NIVEL_3_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779243029/hf_20260520_020403_40cdf111-dce3-4c2f-a06e-63b3ac98c89f_lcw2za.webp';
const products = [{
  badge: 'Nivel 1',
  name: 'Médico en Proceso™',
  summary: 'El contenido central de toda la carrera de Medicina, organizado por ejes y listo para estudiar desde el primer día.',
  tags: ['📚 6 Tomos', '🎁 6 Bonos'],
  image: NIVEL_1_IMG,
  color: 'rgb(240,249,255)',
  border: 'rgba(14,165,233,0.2)'
}, {
  badge: 'Nivel 2',
  name: 'Sistema Carrera Organizada™',
  summary: 'Todo el Megapack más un sistema para planificar, organizarte y no improvisar más en Guardia ni en Medicina Interna.',
  tags: ['📚 Todo el Nivel 1', '🏥 Tomo Guardia', '📝 Tomo Medicina Interna'],
  image: NIVEL_2_IMG,
  color: 'rgb(224,242,254)',
  border: 'rgba(2,132,199,0.3)'
}, {
  badge: 'Nivel 3',
  name: 'Sistema de Gestión Académica™',
  summary: 'La versión completa. Todo el sistema más 7 editables premium para dominar cada materia y organizar toda la carrera.',
  tags: ['🏆 Todo el Nivel 2', '✏️ 7 Editables premium'],
  image: NIVEL_3_IMG,
  color: 'rgb(186,230,253)',
  border: 'rgba(2,132,199,0.4)'
}];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(224,242,254) 15%, rgb(186,230,253) 100%)'
  }} data-id="element-317">
      <div className="mx-auto max-w-4xl" data-id="element-318">

        {/* Label */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase mb-2" style={{
        color: '#0284c7'
      }} data-id="element-319">
          Tres niveles. Un solo objetivo.
        </p>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-320">
          Elegí según dónde estás en la carrera
        </h2>

        <p className="text-center text-sm text-gray-500 mx-auto max-w-lg m-0 mb-8" data-id="element-321">
          Material construido sobre los planes de estudio oficiales de UBA, UNLP,
          UNC y las principales universidades de Argentina.{' '}
          <strong className="text-gray-700" data-id="element-322">
            Organizado por ejes curriculares para que estudies lo correcto, en
            orden.
          </strong>
        </p>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6" data-id="element-323">
          {products.map(product => <div key={product.badge} className="rounded-xl border flex flex-col shadow-sm overflow-hidden" style={{
          borderColor: product.border,
          backgroundColor: product.color
        }} data-id="element-324">
              {/* Image */}
              <div className="w-full h-16 overflow-hidden" data-id="element-325">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-326" />
              </div>

              {/* Content */}
              <div className="px-3 py-3 flex flex-col gap-1.5" data-id="element-327">
                <span className="text-[10px] font-black uppercase tracking-widest" style={{
              color: '#0284c7'
            }} data-id="element-328">
                  {product.badge}
                </span>
                <p className="text-sm font-black text-gray-900 m-0 leading-snug" data-id="element-329">
                  {product.name}
                </p>
                <p className="text-xs text-gray-600 m-0 leading-relaxed" data-id="element-330">
                  {product.summary}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-1" data-id="element-331">
                  {product.tags.map(tag => <span key={tag} className="text-[11px] font-semibold text-gray-700 bg-white/80 rounded-full px-2.5 py-1" style={{
                border: '1px solid rgba(14,165,233,0.25)'
              }} data-id="element-332">
                      {tag}
                    </span>)}
                </div>
              </div>
            </div>)}
        </div>

        {/* Footer referencia */}
        <p className="text-center text-xs sm:text-sm text-gray-500 mx-auto max-w-lg mb-6" data-id="element-333">
          👇{' '}
          <strong className="text-gray-700" data-id="element-334">
            Más abajo te mostramos en detalle qué incluye cada nivel, qué
            materias cubre y por qué está organizado así.
          </strong>
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(14,165,233), rgba(255,255,255,0))'
      }} data-id="element-335" />
      </div>

      {/* Degradé de integración con WhatYouGet */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(240,249,255) 100%)'
    }} data-id="element-336" />
    </section>;
}